"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LaptopUser: ['laptop-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.41,4.5a2,2,0,0,0-2-2h-17a2,2,0,0,0-2,2V17.182a.319.319,0,0,1-.32.319A1,1,0,0,0,.1,18.665l.124.747A2.492,2.492,0,0,0,2.7,21.5H21.306a2.492,2.492,0,0,0,2.466-2.089l.124-.746A1,1,0,0,0,22.91,17.5a.5.5,0,0,1-.5-.5Zm-2,12.5a.5.5,0,0,1-.5.5h-16a.5.5,0,0,1-.5-.5V5a.5.5,0,0,1,.5-.5h16a.5.5,0,0,1,.5.5Z', 'M7.423,14.89a.5.5,0,0,0,.487.611h7.525a.5.5,0,0,0,.488-.611,4.334,4.334,0,0,0-2.839-3.158.249.249,0,0,1-.169-.215.252.252,0,0,1,.129-.241,2.863,2.863,0,1,0-2.743,0,.252.252,0,0,1,.129.241.249.249,0,0,1-.169.215A4.331,4.331,0,0,0,7.423,14.89Z']],
  MonitorGraph: ['monitor-graph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.84A2.548,2.548,0,0,0,21.5.251H2.5A2.548,2.548,0,0,0,0,2.84V16.751a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25V20a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3Zm-22,0a.551.551,0,0,1,.5-.589h19a.551.551,0,0,1,.5.589V14.751a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M5.500 9.251 L8.500 9.251 L8.500 13.251 L5.500 13.251 Z', 'M10.500 7.251 L13.500 7.251 L13.500 13.251 L10.500 13.251 Z', 'M15.500 4.751 L18.500 4.751 L18.500 13.251 L15.500 13.251 Z']],
  MonitorHeart1: ['monitor-heart_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.59A2.548,2.548,0,0,0,21.5,0H2.5A2.548,2.548,0,0,0,0,2.59V16.5a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3ZM2.5,15a.5.5,0,0,1-.5-.5V2.59A.551.551,0,0,1,2.5,2h19a.551.551,0,0,1,.5.589V14.5a.5.5,0,0,1-.5.5Z', 'M13.935,4.535a2.49,2.49,0,0,0-2.182.705l-.2.2-.2-.2A2.517,2.517,0,0,0,7.779,8.792l3.409,3.556a.5.5,0,0,0,.723,0l3.4-3.548a2.517,2.517,0,0,0-1.377-4.265Z']],
  MonitorHome: ['monitor-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.59A2.548,2.548,0,0,0,21.5,0H2.5A2.548,2.548,0,0,0,0,2.59V16.5a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3ZM2.5,15a.5.5,0,0,1-.5-.5V2.59A.551.551,0,0,1,2.5,2h19a.551.551,0,0,1,.5.589V14.5a.5.5,0,0,1-.5.5Z', 'M11.969,4.58a.341.341,0,0,0-.438,0L7.12,8.413a.329.329,0,0,0-.1.369A.339.339,0,0,0,7.339,9H8a.5.5,0,0,1,.5.5v3A.5.5,0,0,0,9,13h1a.5.5,0,0,0,.5-.5v-1.25a1.25,1.25,0,1,1,2.5,0V12.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,1,.5-.5h.661a.339.339,0,0,0,.318-.219.329.329,0,0,0-.1-.369Z']],
  LaptopShoppingCart: ['laptop-shopping-cart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.609,13a1.243,1.243,0,0,0,1.165-.8l1.881-4.671a.75.75,0,1,0-1.391-.561l-.289.717A.5.5,0,0,1,14.512,8H8.96A1.251,1.251,0,0,0,7.81,9.743l1.072,2.5A1.248,1.248,0,0,0,10.031,13Z', 'M9.460 14.500 A1.000 1.000 0 1 0 11.460 14.500 A1.000 1.000 0 1 0 9.460 14.500 Z', 'M13.21,13.5h0a1,1,0,1,0,1,1A1,1,0,0,0,13.209,13.5Z', 'M22.41,4.5a2,2,0,0,0-2-2h-17a2,2,0,0,0-2,2V17.182a.319.319,0,0,1-.32.319A1,1,0,0,0,.1,18.665l.124.747A2.492,2.492,0,0,0,2.7,21.5H21.306a2.492,2.492,0,0,0,2.466-2.089l.124-.746A1,1,0,0,0,22.91,17.5a.5.5,0,0,1-.5-.5Zm-2,12.5a.5.5,0,0,1-.5.5h-16a.5.5,0,0,1-.5-.5V5a.5.5,0,0,1,.5-.5h16a.5.5,0,0,1,.5.5Z']],
  MonitorCamera: ['monitor-camera', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,23.751a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25V20a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3V2.84A2.548,2.548,0,0,0,21.5.251H2.5A2.548,2.548,0,0,0,0,2.84V16.751a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2ZM2,2.84a.551.551,0,0,1,.5-.589h19a.551.551,0,0,1,.5.589V14.751a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M15.5,6.251a1,1,0,0,0-1-1h-6a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1v-.32a.25.25,0,0,1,.1-.2.248.248,0,0,1,.225-.034l1.342.447a.248.248,0,0,0,.225-.034.252.252,0,0,0,.1-.2V6.584a.25.25,0,0,0-.32-.24l-1.36.4a.25.25,0,0,1-.32-.24Z']],
  MonitorUser: ['monitor-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.59A2.548,2.548,0,0,0,21.5,0H2.5A2.548,2.548,0,0,0,0,2.59V16.5a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3ZM2.5,15a.5.5,0,0,1-.5-.5V2.59A.551.551,0,0,1,2.5,2h19a.551.551,0,0,1,.5.589V14.5a.5.5,0,0,1-.5.5Z', 'M13.174,10.232a.25.25,0,0,1-.039-.456,2.863,2.863,0,1,0-2.744,0,.252.252,0,0,1,.129.241.249.249,0,0,1-.169.215A4.329,4.329,0,0,0,7.513,13.39.5.5,0,0,0,8,14h7.525a.5.5,0,0,0,.488-.611A4.332,4.332,0,0,0,13.174,10.232Z']],
  MonitorMovie: ['monitor-movie', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.84A2.548,2.548,0,0,0,21.5.251H2.5A2.548,2.548,0,0,0,0,2.84V16.751a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25V20a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3Zm-22,0a.551.551,0,0,1,.5-.589h19a.551.551,0,0,1,.5.589V14.751a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M6.25,5.251h2a1,1,0,0,0,0-2h-2a1,1,0,0,0,0,2Z', 'M10.75,5.251h2a1,1,0,0,0,0-2h-2a1,1,0,0,0,0,2Z', 'M18.25,4.251a1,1,0,0,0-1-1h-2a1,1,0,1,0,0,2h2A1,1,0,0,0,18.25,4.251Z', 'M9.25,13.251a1,1,0,0,0-1-1h-2a1,1,0,1,0,0,2h2A1,1,0,0,0,9.25,13.251Z', 'M12.75,12.251h-2a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z', 'M18.25,13.251a1,1,0,0,0-1-1h-2a1,1,0,0,0,0,2h2A1,1,0,0,0,18.25,13.251Z', 'M5.500 6.251 L11.000 6.251 L11.000 11.251 L5.500 11.251 Z', 'M12.500 6.251 L18.000 6.251 L18.000 11.251 L12.500 11.251 Z']],
  MonitorPlay: ['monitor-play', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.84A2.548,2.548,0,0,0,21.5.251H2.5A2.548,2.548,0,0,0,0,2.84V16.751a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25V20a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3Zm-22,0a.551.551,0,0,1,.5-.589h19a.551.551,0,0,1,.5.589V14.751a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M9.3,11.356a.645.645,0,0,0,.977.553l5.91-2.73a.645.645,0,0,0,0-1.106l-5.91-2.73A.644.644,0,0,0,9.3,5.9Z']],
  AppWindowAdd: ['app-window-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.5,7.25H18.5a.25.25,0,0,0-.25.25V20a.75.75,0,1,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,0,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,1,1,1.5,0v1.5a.25.25,0,0,0,.25.25H20a.75.75,0,0,1,0,1.5Z', 'M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H8a1,1,0,0,0,1-1H9a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V9.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindow1: ['app-window-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,7.251a3,3,0,0,0-3-3H5.5a3,3,0,0,0-3,3v9.5a3,3,0,0,0,3,3h13a3,3,0,0,0,3-3Zm-9.346-1a.966.966,0,0,1,1.692,0,.889.889,0,0,1,0,1,.966.966,0,0,1-1.692,0,.889.889,0,0,1,0-1Zm-3.5,0a.966.966,0,0,1,1.692,0,.889.889,0,0,1,0,1,.966.966,0,0,1-1.692,0,.889.889,0,0,1,0-1Zm-3.562.091A1,1,0,0,1,6,5.751a.983.983,0,0,1,.846.5.889.889,0,0,1,0,1,.966.966,0,0,1-1.692,0A.972.972,0,0,1,5,6.751.987.987,0,0,1,5.092,6.342ZM19.5,16.751a1,1,0,0,1-1,1H5.5a1,1,0,0,1-1-1V9.5a.25.25,0,0,1,.25-.25h14.5a.25.25,0,0,1,.25.25Z']],
  AppWindowBookmark: ['app-window-bookmark', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.5a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v15a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3ZM3,5A1,1,0,1,1,4,6,1,1,0,0,1,3,5ZM6,5A1,1,0,1,1,7,6,1,1,0,0,1,6,5ZM9,5a1,1,0,1,1,1,1A1,1,0,0,1,9,5ZM22,19.5a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V9a.5.5,0,0,1,.5-.5h19A.5.5,0,0,1,22,9Z', 'M13.542,18.472a.887.887,0,0,0,.334.066.871.871,0,0,0,.618-.257l1.829-1.83a.251.251,0,0,1,.354,0l1.829,1.83A.875.875,0,0,0,20,17.662V9.818a.5.5,0,0,0-.5-.5h-6a.5.5,0,0,0-.5.5v7.844A.876.876,0,0,0,13.542,18.472Z']],
  AppWindowCash1: ['app-window-cash-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.525,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.525,11Zm.533,8.75a.592.592,0,0,0,.221-1.141l-2.065-.826a2.084,2.084,0,0,1,.361-3.98.249.249,0,0,0,.2-.245v-.308a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25h.5a.75.75,0,0,1,0,1.5H16.992a.591.591,0,0,0-.221,1.14l2.064.827a2.084,2.084,0,0,1-.36,3.98.25.25,0,0,0-.2.245v.308a.75.75,0,0,1-1.5,0V21.5a.25.25,0,0,0-.25-.25h-.5a.75.75,0,1,1,0-1.5Z', 'M9.222,19.222a.97.97,0,0,0-.951-.721h-5.3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.225,5h19.5a.25.25,0,0,1,.25.25v4.781a1,1,0,0,0,.388.777l.022.018a.983.983,0,0,0,1.59-.778V3a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3V17.5a3,3,0,0,0,3,3h5.3a1,1,0,0,0,.95-1.256ZM9.629,2a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5A.967.967,0,0,1,9.629,3a.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.629,2Zm-3.5,0A.967.967,0,0,1,7.822,2a.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5A.967.967,0,0,1,6.129,3a.972.972,0,0,1-.154-.5A.969.969,0,0,1,6.129,2Zm-3.562.091A1,1,0,0,1,3.475,1.5a.986.986,0,0,1,.847.5.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5A.967.967,0,0,1,2.629,3a.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.567,2.092Z']],
  AppWindowCheck: ['app-window-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.525,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.525,11ZM20.8,16.206l-2.9,3.874a1.494,1.494,0,0,1-1.1.6c-.037,0-.074.005-.111.005a1.494,1.494,0,0,1-1.055-.443l-1.5-1.5a.75.75,0,1,1,1.061-1.06l1.3,1.3a.251.251,0,0,0,.377-.027L19.6,15.306a.75.75,0,1,1,1.2.9Z', 'M23.975,3a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3V17.5a3,3,0,0,0,3,3h5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-5a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.225,5h19.5a.25.25,0,0,1,.25.25V9.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.322,3A.967.967,0,0,1,2.629,3a.972.972,0,0,1-.154-.5.987.987,0,0,1,.092-.409A1,1,0,0,1,3.475,1.5a.986.986,0,0,1,.847.5.977.977,0,0,1,.153.5A.98.98,0,0,1,4.322,3Zm3.5,0A.967.967,0,0,1,6.129,3a.972.972,0,0,1-.154-.5A.969.969,0,0,1,6.129,2,.967.967,0,0,1,7.822,2a.977.977,0,0,1,.153.5A.98.98,0,0,1,7.822,3Zm3.5,0A.967.967,0,0,1,9.629,3a.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.629,2a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5A.98.98,0,0,1,11.322,3Z']],
  AppWindowCash: ['app-window-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.473,14.016l2.062.825a.342.342,0,0,1-.126.66H10.375a1,1,0,0,0,0,2h.25a.25.25,0,0,1,.25.25,1,1,0,0,0,2,0v-.1a.251.251,0,0,1,.181-.241,2.342,2.342,0,0,0,.222-4.425l-2.062-.825a.341.341,0,0,1,.126-.658h2.033a1,1,0,0,0,0-2h-.25a.25.25,0,0,1-.25-.25,1,1,0,1,0-2,0v.1a.251.251,0,0,1-.181.24,2.341,2.341,0,0,0-.221,4.424Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowBadge: ['app-window-badge', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14,19.7a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.452a.25.25,0,0,1,.25-.25h19.5a.25.25,0,0,1,.25.25V7.7a1,1,0,0,0,2,0V3.2a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3V17.7a3,3,0,0,0,3,3H13A1,1,0,0,0,14,19.7ZM9.654,2.2a.966.966,0,0,1,1.692,0,.972.972,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,9.5,2.7.972.972,0,0,1,9.654,2.2Zm-3.5,0a.966.966,0,0,1,1.692,0A.972.972,0,0,1,8,2.7a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,2.7.972.972,0,0,1,6.154,2.2Zm-3.562.092A1,1,0,0,1,3.5,1.7a.985.985,0,0,1,.846.5.972.972,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,2.5,2.7.979.979,0,0,1,2.592,2.294Z', 'M19.251,19.369a2.977,2.977,0,0,1-2.382-1.176.247.247,0,0,0-.162-.1c-.051-.008-.1-.018-.152-.029a.25.25,0,0,0-.306.244V23.3a.5.5,0,0,0,.821.384L19.089,22a.251.251,0,0,1,.32,0l2.02,1.683a.5.5,0,0,0,.82-.384V18.311a.249.249,0,0,0-.093-.2.257.257,0,0,0-.212-.049c-.049.012-.1.021-.15.029a.249.249,0,0,0-.162.1A2.975,2.975,0,0,1,19.251,19.369Z', 'M23.5,12.2a2,2,0,0,0-2-2,1.793,1.793,0,0,0-.322.031.251.251,0,0,1-.256-.11,1.979,1.979,0,0,0-3.345,0,.251.251,0,0,1-.256.11A1.793,1.793,0,0,0,17,10.2a2,2,0,0,0-2,2,1.97,1.97,0,0,0,.519,1.332.251.251,0,0,1,0,.336A1.972,1.972,0,0,0,15,15.2a2,2,0,0,0,2,2,1.794,1.794,0,0,0,.322-.03.25.25,0,0,1,.256.11,1.98,1.98,0,0,0,3.345,0,.25.25,0,0,1,.256-.11,1.794,1.794,0,0,0,.322.03,2,2,0,0,0,2-2,1.972,1.972,0,0,0-.519-1.332.251.251,0,0,1,0-.336A1.97,1.97,0,0,0,23.5,12.2Zm-4.251,3a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,19.249,15.2Z']],
  AppWindowDownload: ['app-window-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.646,15.612a.5.5,0,0,0,.708,0l3-3.008A.5.5,0,0,0,15,11.751H13.25A.25.25,0,0,1,13,11.5V9.251a1,1,0,1,0-2,0V11.5a.25.25,0,0,1-.25.25H9a.5.5,0,0,0-.354.853Z', 'M7.5,18.751h9a1.5,1.5,0,0,0,1.5-1.5V15.759a1,1,0,0,0-2,0V16.5a.25.25,0,0,1-.25.25H8.25A.25.25,0,0,1,8,16.5v-.742a1,1,0,0,0-2,0v1.492A1.5,1.5,0,0,0,7.5,18.751Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowCode: ['app-window-code', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,19.251a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3Zm14.5-15a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0A.969.969,0,0,1,14.5,4.251Zm3.5,0a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0A.969.969,0,0,1,18,4.251Zm3.5,0a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.983.983,0,0,1,.846-.5,1,1,0,0,1,.908.591A.987.987,0,0,1,21.5,4.251ZM2,7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7v12.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1Z', 'M6.793,16.458a1,1,0,0,0,1.414,0l2.5-2.5a1,1,0,0,0,0-1.414l-2.5-2.5a1,1,0,0,0-1.414,1.414l1.616,1.616a.25.25,0,0,1,0,.354L6.793,15.044A1,1,0,0,0,6.793,16.458Z', 'M13,16.751h4a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z']],
  AppWindowLayout1: ['app-window-layout-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.500 9.251 L8.500 9.251 L8.500 12.251 L4.500 12.251 Z', 'M4.500 14.251 L8.500 14.251 L8.500 17.251 L4.500 17.251 Z', 'M11,11.5h8.5a.75.75,0,0,0,0-1.5H11a.75.75,0,0,0,0,1.5Z', 'M11,16.5h8.5a.75.75,0,0,0,0-1.5H11a.75.75,0,0,0,0,1.5Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowLock1: ['app-window-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.5,15A1.5,1.5,0,0,0,10,16.5h4A1.5,1.5,0,0,0,15.5,15h0V12a1.5,1.5,0,0,0-.857-1.349.25.25,0,0,1-.143-.226V10a2.5,2.5,0,0,0-5,0v.425a.25.25,0,0,1-.143.226A1.5,1.5,0,0,0,8.5,12v3ZM12,14.52a1,1,0,1,1,1-1A1,1,0,0,1,12,14.52Zm-1.25-4.436a1.25,1.25,0,0,1,2.5,0v.209a.208.208,0,0,1-.208.208H10.958a.208.208,0,0,1-.208-.208Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowHeart: ['app-window-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.887,13.628l-.388.387-.387-.387a3.668,3.668,0,0,0-2.7-1.127,3.526,3.526,0,0,0-2.391,6.011l5.113,5.335a.5.5,0,0,0,.723,0l5.106-5.328A3.527,3.527,0,0,0,20.582,12.5,3.666,3.666,0,0,0,17.887,13.628Z', 'M21,0H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H9a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V10a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V3A3,3,0,0,0,21,0ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowHome: ['app-window-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.676,12.119l-6.5,5.5a.5.5,0,0,0,.324.882h1.25a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.5.5H15a.5.5,0,0,0,.5-.5v-2.25a1.5,1.5,0,0,1,3,0V23.5a.5.5,0,0,0,.5.5h2.5a.5.5,0,0,0,.5-.5v-4.75a.25.25,0,0,1,.25-.25H23.5a.5.5,0,0,0,.323-.882l-6.5-5.5A.5.5,0,0,0,16.676,12.119Z', 'M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H7a1,1,0,0,0,1-1H8a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V12.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowModule: ['app-window-module', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.000 19.001 L24.000 19.001 L24.000 24.001 L19.000 24.001 Z', 'M12.500 19.001 L17.500 19.001 L17.500 24.001 L12.500 24.001 Z', 'M16.000 12.501 L21.000 12.501 L21.000 17.501 L16.000 17.501 Z', 'M21,0H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H9.5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V11a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V3A3,3,0,0,0,21,0ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowMoveDown: ['app-window-move-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.05,10.251h2.013a.75.75,0,0,0,0-1.5H17.05a.75.75,0,0,0,0,1.5Z', 'M11.05,10.251h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z', 'M5.05,10.251h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,1,0,0,1.5Z', 'M11.646,18.6a.5.5,0,0,0,.707,0l2.5-2.5a.5.5,0,0,0-.353-.853H13.25A.25.25,0,0,1,13,15V12.274a1,1,0,0,0-2,0V15a.25.25,0,0,1-.25.25H9.5a.5.5,0,0,0-.354.853Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowMoveLeft: ['app-window-move-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,19.251a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3Zm10.5-16a1.035,1.035,0,0,1,1,1,1,1,0,1,1-2,0A1.035,1.035,0,0,1,10.5,3.251Zm-3.5,0a1.035,1.035,0,0,1,1,1,1,1,0,1,1-2,0A1.035,1.035,0,0,1,7,3.251Zm-3.5,0a1.035,1.035,0,0,1,1,1,1.035,1.035,0,0,1-1,1,1.035,1.035,0,0,1-1-1A1.008,1.008,0,0,1,3.5,3.251ZM2,7a.25.25,0,0,1,.25-.25h13.5A.25.25,0,0,1,16,7V8.5a.75.75,0,0,0,1.5,0V7a.25.25,0,0,1,.25-.25h4A.25.25,0,0,1,22,7v12.25a1,1,0,0,1-1,1H17.75A.25.25,0,0,1,17.5,20V18.5a.75.75,0,0,0-1.5,0V20a.25.25,0,0,1-.25.25H3a1,1,0,0,1-1-1Z', 'M16.75,11.751a.75.75,0,0,1,.75.75v2a.75.75,0,0,1-1.5,0v-2A.75.75,0,0,1,16.75,11.751Z', 'M8.146,10.646a.505.505,0,0,1,.545-.109A.5.5,0,0,1,9,11v1.25a.25.25,0,0,0,.25.25H13a1,1,0,0,1,0,2H9.25a.25.25,0,0,0-.25.25V16a.5.5,0,0,1-.309.462.5.5,0,0,1-.545-.108l-2.5-2.5a.5.5,0,0,1,0-.707Z']],
  AppWindowMinimize: ['app-window-minimize', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.622,16.9a.5.5,0,0,0,.353.854h4.5a.5.5,0,0,0,.5-.5v-4.5a.5.5,0,0,0-.853-.354l-1.367,1.367a.25.25,0,0,1-.353,0l-3.72-3.72a1,1,0,0,0-1.414,1.414l3.72,3.72a.25.25,0,0,1,0,.353Z', 'M14.025 18.751 L24.025 18.751 L24.025 22.751 L14.025 22.751 Z', 'M9.975,20.751a1,1,0,0,0-1-1h-6a1,1,0,0,1-1-1V6.5a.25.25,0,0,1,.25-.25h19.5a.25.25,0,0,1,.25.25v7.25a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1v-9.5a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3h6a1,1,0,0,0,1-1Zm-.346-17.5a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5.967.967,0,0,1-1.693,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.629,3.251Zm-3.5,0a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5.967.967,0,0,1-1.693,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,6.129,3.251Zm-3.562.091a1,1,0,0,1,.908-.591.986.986,0,0,1,.847.5.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5.967.967,0,0,1-1.693,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.567,3.342Z']],
  AppWindowMinimize1: ['app-window-minimize_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.211,10.991a.25.25,0,0,1,0,.354l-.271.271a.5.5,0,0,0,.354.854H10.25a.5.5,0,0,0,.5-.5V10.013A.5.5,0,0,0,9.9,9.659l-.271.272a.25.25,0,0,1-.353,0L7.78,8.439A.75.75,0,1,0,6.72,9.5Z', 'M13.251,12.47h1.956a.5.5,0,0,0,.354-.854l-.271-.271a.25.25,0,0,1,0-.354L16.781,9.5a.75.75,0,0,0-1.06-1.061L14.229,9.931a.25.25,0,0,1-.353,0L13.6,9.659a.5.5,0,0,0-.853.354V11.97A.5.5,0,0,0,13.251,12.47Z', 'M7.25,18.751a.744.744,0,0,0,.53-.22L9.271,17.04a.25.25,0,0,1,.354,0l.271.271a.5.5,0,0,0,.354.147.508.508,0,0,0,.191-.038.5.5,0,0,0,.309-.462V15a.5.5,0,0,0-.5-.5H8.293a.5.5,0,0,0-.354.853l.272.272a.249.249,0,0,1,0,.353L6.72,17.471a.75.75,0,0,0,.53,1.28Z', 'M13.059,17.42a.508.508,0,0,0,.191.038.5.5,0,0,0,.354-.147l.271-.271a.25.25,0,0,1,.354,0l1.491,1.491a.75.75,0,0,0,1.06-1.06l-1.491-1.492a.249.249,0,0,1,0-.353l.272-.272a.5.5,0,0,0-.354-.853H13.25a.5.5,0,0,0-.5.5v1.957A.5.5,0,0,0,13.059,17.42Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowMoveRight: ['app-window-move-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H8.25A.25.25,0,0,1,8,20V18.5a.75.75,0,0,0-1.5,0V20a.25.25,0,0,1-.25.25H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h4A.25.25,0,0,1,6.5,7V8.5A.75.75,0,0,0,8,8.5V7a.25.25,0,0,1,.25-.25h13.5A.25.25,0,0,1,22,7Z', 'M7.25,11.751a.75.75,0,0,0-.75.75v2a.75.75,0,0,0,1.5,0v-2A.75.75,0,0,0,7.25,11.751Z', 'M15.854,10.646a.505.505,0,0,0-.545-.109A.5.5,0,0,0,15,11v1.25a.25.25,0,0,1-.25.25H11a1,1,0,0,0,0,2h3.75a.25.25,0,0,1,.25.25V16a.5.5,0,0,0,.309.462.5.5,0,0,0,.545-.108l2.5-2.5a.5.5,0,0,0,0-.707Z']],
  AppWindowStar: ['app-window-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.83,14.508a.249.249,0,0,1,.086.305l-.837,1.921a1.067,1.067,0,0,0,.268,1.231,1.085,1.085,0,0,0,1.276.141l2.247-1.264a.251.251,0,0,1,.246,0l2.246,1.264a1.108,1.108,0,0,0,.543.145,1.089,1.089,0,0,0,.733-.286,1.065,1.065,0,0,0,.267-1.231l-.837-1.923a.249.249,0,0,1,.085-.3l1.516-1.064a1.069,1.069,0,0,0,.254-1.168,1.049,1.049,0,0,0-.994-.65H14.2a.25.25,0,0,1-.234-.162L12.991,8.9c-.007-.017-.014-.034-.022-.049a1.124,1.124,0,0,0-1.975.048l-.974,2.569a.25.25,0,0,1-.234.162H8.054a1.048,1.048,0,0,0-.993.648A1.094,1.094,0,0,0,7.382,13.5Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  LaptopHome: ['laptop-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.611,10.782A.34.34,0,0,0,7.93,11h.91a.25.25,0,0,1,.25.25V14.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1.25a1.25,1.25,0,0,1,2.5,0V14.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-3.25a.25.25,0,0,1,.25-.25h.911a.341.341,0,0,0,.319-.219.329.329,0,0,0-.1-.369L12.56,6.58a.343.343,0,0,0-.439,0L7.71,10.413A.33.33,0,0,0,7.611,10.782Z', 'M22.41,4.5a2,2,0,0,0-2-2h-17a2,2,0,0,0-2,2V17.182a.319.319,0,0,1-.32.319A1,1,0,0,0,.1,18.665l.124.747A2.492,2.492,0,0,0,2.7,21.5H21.306a2.492,2.492,0,0,0,2.466-2.089l.124-.746A1,1,0,0,0,22.91,17.5a.5.5,0,0,1-.5-.5Zm-2,12.5a.5.5,0,0,1-.5.5h-16a.5.5,0,0,1-.5-.5V5a.5.5,0,0,1,.5-.5h16a.5.5,0,0,1,.5.5Z']],
  LaptopShield: ['laptop-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.41,4.5a2,2,0,0,0-2-2h-17a2,2,0,0,0-2,2V17.182a.319.319,0,0,1-.32.319A1,1,0,0,0,.1,18.665l.124.747A2.492,2.492,0,0,0,2.7,21.5H21.306a2.492,2.492,0,0,0,2.466-2.089l.124-.746A1,1,0,0,0,22.91,17.5a.5.5,0,0,1-.5-.5Zm-2,12.5a.5.5,0,0,1-.5.5h-16a.5.5,0,0,1-.5-.5V5a.5.5,0,0,1,.5-.5h16a.5.5,0,0,1,.5.5Z', 'M10.977,14.759l.369.141a1.545,1.545,0,0,0,1.1,0h0l.367-.14a5.334,5.334,0,0,0,3.6-4.693V7.805a1.193,1.193,0,0,0-.719-1.1A10.9,10.9,0,0,0,11.9,6a10.814,10.814,0,0,0-3.764.707,1.194,1.194,0,0,0-.721,1.1v2.261A5.313,5.313,0,0,0,10.977,14.759ZM10.41,9.751h.5a.25.25,0,0,0,.25-.25V9a.75.75,0,0,1,1.5,0v.5a.25.25,0,0,0,.25.25h.5a.75.75,0,0,1,0,1.5h-.5a.25.25,0,0,0-.25.25V12a.75.75,0,1,1-1.5,0v-.5a.25.25,0,0,0-.25-.25h-.5a.75.75,0,0,1,0-1.5Z']],
  LaptopHeart1: ['laptop-heart_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.41,4.5a2,2,0,0,0-2-2h-17a2,2,0,0,0-2,2V17.182a.319.319,0,0,1-.32.319A1,1,0,0,0,.1,18.665l.124.747A2.492,2.492,0,0,0,2.7,21.5H21.306a2.492,2.492,0,0,0,2.466-2.089l.124-.746A1,1,0,0,0,22.91,17.5a.5.5,0,0,1-.5-.5Zm-2,12.5a.5.5,0,0,1-.5.5h-16a.5.5,0,0,1-.5-.5V5a.5.5,0,0,1,.5-.5h16a.5.5,0,0,1,.5.5Z', 'M11.279,14.513a.5.5,0,0,0,.722,0l3.4-3.549a2.517,2.517,0,1,0-3.56-3.559l-.026.026a.25.25,0,0,1-.354,0l-.026-.026a2.518,2.518,0,0,0-4.032.654,2.511,2.511,0,0,0,.464,2.9Z']],
  AppWindowEdit: ['app-window-edit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.739,20.047a.5.5,0,0,0-.478-.131.5.5,0,0,0-.356.347l-.885,3.1A.5.5,0,0,0,11.5,24a.47.47,0,0,0,.138-.02l3.1-.885a.5.5,0,0,0,.216-.834Z', 'M18.771,13.229a.5.5,0,0,0-.707,0l-5.01,5.011a.5.5,0,0,0,0,.707l3,3a.5.5,0,0,0,.707,0l5.01-5.011a.5.5,0,0,0,0-.707Z', 'M23.232,11.768a2.64,2.64,0,0,0-3.753.047.5.5,0,0,0,0,.707l3,3a.454.454,0,0,0,.327.125.611.611,0,0,0,.426-.172A2.622,2.622,0,0,0,23.232,11.768Z', 'M21,0H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H9a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V8.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V3A3,3,0,0,0,21,0ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowError404: ['app-window-error-404', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.05,16.751A2.253,2.253,0,0,0,14.3,14.5v-2a2.25,2.25,0,0,0-4.5,0v2A2.253,2.253,0,0,0,12.05,16.751ZM11.3,12.5a.75.75,0,0,1,1.5,0v2a.75.75,0,1,1-1.5,0Z', 'M8.8,11.011a.751.751,0,0,0-1.082-.673,6.272,6.272,0,0,0-3.395,4.535.75.75,0,0,0,.739.878H7.05A.25.25,0,0,1,7.3,16a.75.75,0,1,0,1.5,0ZM6.859,12.874a.25.25,0,0,1,.441.162V14a.25.25,0,0,1-.25.25H6.423a.251.251,0,0,1-.226-.359A4.848,4.848,0,0,1,6.859,12.874Z', 'M19.787,11a.75.75,0,0,0-.354-.637.742.742,0,0,0-.728-.035,6.272,6.272,0,0,0-3.395,4.534.751.751,0,0,0,.74.878h1.987a.25.25,0,0,1,.25.25.75.75,0,0,0,1.5,0Zm-1.941,1.863a.25.25,0,0,1,.441.162v.965a.25.25,0,0,1-.25.25H17.41a.249.249,0,0,1-.225-.358A4.786,4.786,0,0,1,17.846,12.864Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowExpand: ['app-window-expand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.563,10.059a.5.5,0,0,1,.462-.308h4.5a.5.5,0,0,1,.5.5v4.5a.5.5,0,0,1-.854.353l-1.366-1.366a.25.25,0,0,0-.353,0l-3.72,3.72a1,1,0,0,1-1.414-1.414l3.72-3.72a.25.25,0,0,0,0-.353L10.671,10.6A.5.5,0,0,1,10.563,10.059Z', 'M-0.025 18.751 L9.975 18.751 L9.975 22.751 L-0.025 22.751 Z', 'M15.025,19.751a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h6a3,3,0,0,0,3-3V4.251a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3v9.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V6.5a.25.25,0,0,1,.25-.25h19.5a.25.25,0,0,1,.25.25v12.25a1,1,0,0,1-1,1Zm-5.4-16.5a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5.967.967,0,0,1-1.693,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.629,3.251Zm-3.5,0a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5.967.967,0,0,1-1.693,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,6.129,3.251Zm-3.562.091a1,1,0,0,1,.908-.591.986.986,0,0,1,.847.5.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5.967.967,0,0,1-1.693,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.567,3.342Z']],
  AppWindowExpand1: ['app-window-expand-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.358,11.17a.513.513,0,0,0,.192.038.5.5,0,0,0,.353-.147l.272-.271a.25.25,0,0,1,.353,0l1.491,1.491a.75.75,0,1,0,1.061-1.06L9.588,9.729a.252.252,0,0,1,0-.354L9.859,9.1a.5.5,0,0,0-.353-.853H7.55a.5.5,0,0,0-.5.5v1.957A.5.5,0,0,0,7.358,11.17Z', 'M13.55,12.5a.744.744,0,0,0,.53-.22l1.491-1.491a.251.251,0,0,1,.354,0l.271.271a.5.5,0,0,0,.354.147.508.508,0,0,0,.191-.038.5.5,0,0,0,.309-.462V8.751a.5.5,0,0,0-.5-.5H14.594a.5.5,0,0,0-.354.853l.271.271a.25.25,0,0,1,0,.354l-1.492,1.492a.75.75,0,0,0,.531,1.28Z', 'M7.55,18.251H9.506a.5.5,0,0,0,.353-.854l-.271-.271a.25.25,0,0,1,0-.353l1.492-1.492a.75.75,0,0,0-1.061-1.06L8.528,15.712a.25.25,0,0,1-.353,0L7.9,15.44a.506.506,0,0,0-.545-.108.5.5,0,0,0-.308.462v1.957A.5.5,0,0,0,7.55,18.251Z', 'M14.511,16.773a.249.249,0,0,1,0,.353l-.271.271a.5.5,0,0,0,.354.854H16.55a.5.5,0,0,0,.5-.5V15.794a.5.5,0,0,0-.309-.462.505.505,0,0,0-.545.108l-.271.272a.251.251,0,0,1-.354,0L14.08,14.221a.75.75,0,0,0-1.061,1.06Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowSubtract: ['app-window-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.525,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.525,11Zm2.5,7.25h-5a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Z', 'M23.975,3a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3V17.5a3,3,0,0,0,3,3h5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-5a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.225,5h19.5a.25.25,0,0,1,.25.25V9.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.322,3A.967.967,0,0,1,2.629,3a.972.972,0,0,1-.154-.5.987.987,0,0,1,.092-.409A1,1,0,0,1,3.475,1.5a.986.986,0,0,1,.847.5.977.977,0,0,1,.153.5A.98.98,0,0,1,4.322,3Zm3.5,0A.967.967,0,0,1,6.129,3a.972.972,0,0,1-.154-.5A.969.969,0,0,1,6.129,2,.967.967,0,0,1,7.822,2a.977.977,0,0,1,.153.5A.98.98,0,0,1,7.822,3Zm3.5,0A.967.967,0,0,1,9.629,3a.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.629,2a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5A.98.98,0,0,1,11.322,3Z']],
  AppWindowDownload2: ['app-window-download-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.354,19.854A.5.5,0,0,0,16,19H14a.5.5,0,0,1-.5-.5V12a1.5,1.5,0,1,0-3,0v6.5a.5.5,0,0,1-.5.5H8a.5.5,0,0,0-.353.853l4,4a.5.5,0,0,0,.707,0Z', 'M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V15a3,3,0,0,0,3,3H6.5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V15a1,1,0,0,1-1,1H17.5a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1H21a3,3,0,0,0,3-3ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowFour: ['app-window-four', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3,11H8.5a2.753,2.753,0,0,0,2.75-2.75v-4.5A2.752,2.752,0,0,0,8.5,1H3A2.752,2.752,0,0,0,.25,3.751v4.5A2.753,2.753,0,0,0,3,11ZM1.75,4.751A.25.25,0,0,1,2,4.5H9.5a.25.25,0,0,1,.25.25v3.5A1.252,1.252,0,0,1,8.5,9.5H3a1.252,1.252,0,0,1-1.25-1.25Z', 'M12.75,8.251A2.753,2.753,0,0,0,15.5,11H21a2.753,2.753,0,0,0,2.75-2.75v-4.5A2.752,2.752,0,0,0,21,1H15.5a2.752,2.752,0,0,0-2.75,2.75Zm1.5-3.5a.25.25,0,0,1,.25-.25H22a.25.25,0,0,1,.25.25v3.5A1.252,1.252,0,0,1,21,9.5H15.5a1.252,1.252,0,0,1-1.25-1.25Z', 'M3,23H8.5a2.753,2.753,0,0,0,2.75-2.75v-4.5A2.752,2.752,0,0,0,8.5,13H3a2.752,2.752,0,0,0-2.75,2.75v4.5A2.753,2.753,0,0,0,3,23Zm-1.25-6.25A.25.25,0,0,1,2,16.5H9.5a.25.25,0,0,1,.25.25v3.5A1.252,1.252,0,0,1,8.5,21.5H3a1.252,1.252,0,0,1-1.25-1.25Z', 'M12.75,20.251A2.753,2.753,0,0,0,15.5,23H21a2.753,2.753,0,0,0,2.75-2.75v-4.5A2.752,2.752,0,0,0,21,13H15.5a2.752,2.752,0,0,0-2.75,2.75Zm1.5-3.5a.25.25,0,0,1,.25-.25H22a.25.25,0,0,1,.25.25v3.5A1.252,1.252,0,0,1,21,21.5H15.5a1.252,1.252,0,0,1-1.25-1.25Z']],
  AppWindowGraph: ['app-window-graph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM2,7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7v5.255a.5.5,0,0,1-.5.5H16.55a.748.748,0,0,0-.636.353l-1.626,2.6a.251.251,0,0,1-.428-.006L9.7,8.627a.712.712,0,0,0-.655-.371.749.749,0,0,0-.647.386L6.251,12.5a.5.5,0,0,1-.437.257H2.5a.5.5,0,0,1-.5-.5Zm20,12.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1v-4.5a.5.5,0,0,1,.5-.5H6.55a.749.749,0,0,0,.655-.385L8.856,10.9a.25.25,0,0,1,.434,0L13.4,17.886a.747.747,0,0,0,.637.37h.01a.744.744,0,0,0,.635-.352l2.134-3.413a.5.5,0,0,1,.424-.235H21.5a.5.5,0,0,1,.5.5Z']],
  AppWindowGraph1: ['app-window-graph-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.55,13.751a1,1,0,0,0,1,1h2a1,1,0,0,0,.874-.515l1.438-2.588a.248.248,0,0,1,.215-.129.252.252,0,0,1,.219.123l3.891,6.616a1,1,0,0,0,.849.493h.014a1,1,0,0,0,.847-.47l2.061-3.295a.5.5,0,0,1,.424-.235H19.55a1,1,0,0,0,0-2h-3a1,1,0,0,0-.848.47L14.3,15.473a.251.251,0,0,1-.428-.006L9.912,8.744a1,1,0,0,0-.862-.493H9.037a1,1,0,0,0-.861.514L6.1,12.494a.5.5,0,0,1-.437.257H4.55A1,1,0,0,0,3.55,13.751Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-9.5-.5a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0A.969.969,0,0,1,14.5,4.251Zm3.5,0a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0A.969.969,0,0,1,18,4.251Zm3.5,0a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.983.983,0,0,1,.846-.5,1,1,0,0,1,.908.591A.987.987,0,0,1,21.5,4.251ZM2,7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7v12.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1Z']],
  AppWindowFlag: ['app-window-flag', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.8,23a1,1,0,0,0,2,0V19.415a.25.25,0,0,1,.17-.237l.082-.028a2.805,2.805,0,0,1,2.5.341,4.31,4.31,0,0,0,2.42.737,4.537,4.537,0,0,0,1.473-.248l.932-.429a.749.749,0,0,0,.436-.681v-5.5a.75.75,0,0,0-1.065-.681l-.858.4a2.8,2.8,0,0,1-2.5-.341,4.348,4.348,0,0,0-3.819-.519l-1.268.43a.75.75,0,0,0-.51.71Z', 'M11.464,19.222a.97.97,0,0,0-.951-.721H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V9a1,1,0,0,0,.388.777l.022.018A.983.983,0,0,0,24,9.018V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3h7.52a1,1,0,0,0,.949-1.256ZM9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2Zm-3.5,0A.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5a.972.972,0,0,1-.154.5A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2Zm-3.562.091A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5.987.987,0,0,1,2.592,2.092Z']],
  AppWindowFlash: ['app-window-flash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.392,16H21.107a.25.25,0,0,1-.25-.25V11.5a.5.5,0,0,0-.332-.47.5.5,0,0,0-.556.154L14.7,17.646A.821.821,0,0,0,15.321,19h1.286a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.332.471.487.487,0,0,0,.168.029.5.5,0,0,0,.388-.183l5.272-6.462A.822.822,0,0,0,22.392,16Z', 'M12.451,19.223A.97.97,0,0,0,11.5,18.5H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25v4.781a1,1,0,0,0,.388.777l.022.018A.982.982,0,0,0,24,10.05V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3h8.506a1,1,0,0,0,.95-1.255ZM9.654,2a.966.966,0,0,1,1.692,0,.972.972,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,9.654,3,.969.969,0,0,1,9.5,2.5.972.972,0,0,1,9.654,2Zm-3.5,0A.966.966,0,0,1,7.846,2,.972.972,0,0,1,8,2.5a.969.969,0,0,1-.154.5A.966.966,0,0,1,6.154,3,.969.969,0,0,1,6,2.5.972.972,0,0,1,6.154,2Zm-3.562.092A1,1,0,0,1,3.5,1.5a.985.985,0,0,1,.846.5.972.972,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,2.654,3,.969.969,0,0,1,2.5,2.5.979.979,0,0,1,2.592,2.093Z']],
  AppWindowPasswordCorrect: ['app-window-password-correct', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.251,16a.75.75,0,0,0-.75-.75h-8a.249.249,0,0,1-.25-.25V11a.249.249,0,0,1,.25-.25h13a.25.25,0,0,1,.25.25v.637a.75.75,0,1,0,1.5,0v-.887a1.5,1.5,0,0,0-1.5-1.5H5.251a1.5,1.5,0,0,0-1.5,1.5v4.5a1.5,1.5,0,0,0,1.5,1.5H13.5A.75.75,0,0,0,14.251,16Z', 'M7.501 13.001 A1.000 1.000 0 1 0 9.501 13.001 A1.000 1.000 0 1 0 7.501 13.001 Z', 'M11.501 13.001 A1.000 1.000 0 1 0 13.501 13.001 A1.000 1.000 0 1 0 11.501 13.001 Z', 'M15,18.251a4.5,4.5,0,1,0,4.5-4.5A4.505,4.505,0,0,0,15,18.251Zm6.732-1.763a.75.75,0,0,1,.15,1.05l-1.937,2.583a1.238,1.238,0,0,1-.913.5.91.91,0,0,1-.091,0,1.245,1.245,0,0,1-.879-.366l-1-1a.75.75,0,0,1,1.06-1.061l.594.594a.249.249,0,0,0,.377-.027l1.591-2.121A.746.746,0,0,1,21.732,16.488Z', 'M24,4.251a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3h9.5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V6.5a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,6.5v5.25a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1Zm-19.654,0a.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,2.751a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,4.251Zm3.5,0a.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,3.751a.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,7.846,4.251Zm3.5,0a.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,4.251Z']],
  AppWindowQuestion: ['app-window-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.577,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.577,11Zm0,11.5a1,1,0,1,1,1-1A1,1,0,0,1,17.577,22.5Zm.913-4.163a.25.25,0,0,0-.163.234v.179a.75.75,0,0,1-1.5,0V18.2a1.255,1.255,0,0,1,.99-1.222,1.125,1.125,0,1,0-1.365-1.1.75.75,0,1,1-1.5,0,2.625,2.625,0,1,1,3.538,2.462Z', 'M9.169,19.222a.968.968,0,0,0-.95-.721h-5.3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.173,5h19.5a.25.25,0,0,1,.25.25v4.781a1,1,0,0,0,.388.777l.022.018a.983.983,0,0,0,1.59-.778V3a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3V17.5a3,3,0,0,0,3,3h5.3a1,1,0,0,0,.95-1.256ZM9.576,2a.967.967,0,0,1,1.693,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5A.967.967,0,0,1,9.576,3a.98.98,0,0,1-.153-.5A.977.977,0,0,1,9.576,2Zm-3.5,0A.967.967,0,0,1,7.769,2a.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5A.967.967,0,0,1,6.076,3a.98.98,0,0,1-.153-.5A.977.977,0,0,1,6.076,2Zm-3.561.091A1,1,0,0,1,3.423,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5A.967.967,0,0,1,2.576,3a.98.98,0,0,1-.153-.5A.987.987,0,0,1,2.515,2.092Z']],
  AppWindowSearch1: ['app-window-search-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.139,19.449a5.515,5.515,0,1,0-1.691,1.69.25.25,0,0,1,.311.035l2.534,2.534a1,1,0,0,0,1.414-1.414L21.173,19.76A.25.25,0,0,1,21.139,19.449ZM16.5,20A3.5,3.5,0,1,1,20,16.5,3.543,3.543,0,0,1,16.5,20Z', 'M21,0H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H9a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V10a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V3A3,3,0,0,0,21,0ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowRss: ['app-window-rss', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M7.250 17.001 A1.500 1.500 0 1 0 10.250 17.001 A1.500 1.500 0 1 0 7.250 17.001 Z', 'M7.75,12.9A5.112,5.112,0,0,1,12.856,18a.75.75,0,0,0,1.5,0A6.613,6.613,0,0,0,7.75,11.4a.75.75,0,0,0,0,1.5Z', 'M7.75,9.262A8.749,8.749,0,0,1,16.489,18a.75.75,0,0,0,1.5,0A10.25,10.25,0,0,0,7.75,7.762a.75.75,0,0,0,0,1.5Z']],
  AppWindowSearch: ['app-window-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,13.241a4.5,4.5,0,0,0,4.5,4.5,4.424,4.424,0,0,0,2.222-.6.251.251,0,0,1,.3.039L15.3,18.458a1,1,0,0,0,1.414-1.414l-1.278-1.278a.25.25,0,0,1-.039-.3,4.425,4.425,0,0,0,.6-2.222,4.5,4.5,0,0,0-9,0Zm4.5-2.5a2.5,2.5,0,0,1,2.5,2.5,2.54,2.54,0,0,1-2.5,2.5,2.5,2.5,0,0,1,0-5Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowShare: ['app-window-share', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.275,11a2.752,2.752,0,0,0-2.75,2.75,2.452,2.452,0,0,0,.063.538.25.25,0,0,1-.116.268l-2.665,1.6a.25.25,0,0,1-.288-.021,2.722,2.722,0,0,0-1.744-.634A2.75,2.75,0,1,0,15.83,20.06a.248.248,0,0,1,.281-.067l2.263.905a.25.25,0,0,1,.156.257c0,.032-.005.064-.005.1a2.78,2.78,0,1,0,.7-1.809.252.252,0,0,1-.281.067L16.676,18.6a.248.248,0,0,1-.156-.257c0-.031,0-.063,0-.095a2.515,2.515,0,0,0-.063-.539.25.25,0,0,1,.116-.268l2.665-1.6a.249.249,0,0,1,.288.022,2.726,2.726,0,0,0,1.744.634,2.75,2.75,0,1,0,0-5.5Z', 'M9.222,19.222a.97.97,0,0,0-.951-.721h-5.3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.225,5h19.5a.25.25,0,0,1,.25.25V8a1,1,0,0,0,.388.777l.022.018a.983.983,0,0,0,1.59-.778V3a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3V17.5a3,3,0,0,0,3,3h5.3a1,1,0,0,0,.95-1.256ZM9.629,2a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5A.967.967,0,0,1,9.629,3a.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.629,2Zm-3.5,0A.967.967,0,0,1,7.822,2a.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5A.967.967,0,0,1,6.129,3a.972.972,0,0,1-.154-.5A.969.969,0,0,1,6.129,2Zm-3.562.091A1,1,0,0,1,3.475,1.5a.986.986,0,0,1,.847.5.977.977,0,0,1,.153.5.98.98,0,0,1-.153.5A.967.967,0,0,1,2.629,3a.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.567,2.092Z']],
  AppWindowUpload2: ['app-window-upload-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.354,14.147A.5.5,0,0,1,16,15H14a.5.5,0,0,0-.5.5V22a1.5,1.5,0,1,1-3,0V15.5A.5.5,0,0,0,10,15H8a.5.5,0,0,1-.353-.854l4-4a.5.5,0,0,1,.707,0Z', 'M24,3.5a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v12a3,3,0,0,0,3,3H6.5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.751a.25.25,0,0,1,.25-.25h19.5a.25.25,0,0,1,.25.25V15.5a1,1,0,0,1-1,1H17.5a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1H21a3,3,0,0,0,3-3ZM4.346,3.5a.966.966,0,0,1-1.692,0A.972.972,0,0,1,2.5,3a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,2a.983.983,0,0,1,.846.5A.969.969,0,0,1,4.5,3,.972.972,0,0,1,4.346,3.5Zm3.5,0a.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,3a.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,3,.972.972,0,0,1,7.846,3.5Zm3.5,0a.966.966,0,0,1-1.692,0A.972.972,0,0,1,9.5,3a.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0A.969.969,0,0,1,11.5,3,.972.972,0,0,1,11.346,3.5Z']],
  AppWindowSkull: ['app-window-skull', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.8,17.751a.5.5,0,0,0,.5.5h1.25a.5.5,0,0,0,.5-.5V16.322a.5.5,0,0,1,.15-.357,4.5,4.5,0,1,0-6.3,0,.5.5,0,0,1,.15.359V17.75a.5.5,0,0,0,.5.5H10.8a.5.5,0,0,0,.5-.5v-1a.75.75,0,0,1,1.5,0Zm1.25-6.5a1,1,0,1,1-1,1A1,1,0,0,1,14.05,11.251Zm-5,1a1,1,0,1,1,1,1A1,1,0,0,1,9.05,12.251Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowSmall: ['app-window-small', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.75,8.5a3,3,0,0,0-3-3H7.25a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3h9.5a3,3,0,0,0,3-3ZM13.9,7.5a.966.966,0,0,1,1.692,0,.889.889,0,0,1,0,1,.966.966,0,0,1-1.692,0,.889.889,0,0,1,0-1Zm-3.5,0a.966.966,0,0,1,1.692,0,.889.889,0,0,1,0,1,.966.966,0,0,1-1.692,0,.889.889,0,0,1,0-1Zm-3.562.091A1,1,0,0,1,7.75,7a.983.983,0,0,1,.846.5.889.889,0,0,1,0,1A.966.966,0,0,1,6.9,8.5.972.972,0,0,1,6.75,8,.987.987,0,0,1,6.842,7.592ZM17.75,15.5a1,1,0,0,1-1,1H7.25a1,1,0,0,1-1-1v-4.75a.25.25,0,0,1,.25-.25h11a.25.25,0,0,1,.25.25Z']],
  AppWindowText1: ['app-window-text-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,19.251a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3Zm14.5-15a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0A.969.969,0,0,1,14.5,4.251Zm3.5,0a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0A.969.969,0,0,1,18,4.251Zm3.5,0a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5.969.969,0,0,1,.154-.5.983.983,0,0,1,.846-.5,1,1,0,0,1,.908.591A.987.987,0,0,1,21.5,4.251ZM2,7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7v12.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1Z', 'M10.25,10.751h8.5a.75.75,0,0,0,0-1.5h-8.5a.75.75,0,0,0,0,1.5Z', 'M5.75,10.751h1.5a.75.75,0,0,0,0-1.5H5.75a.75.75,0,0,0,0,1.5Z', 'M10.25,14.251h8.5a.75.75,0,0,0,0-1.5h-8.5a.75.75,0,0,0,0,1.5Z', 'M5.75,14.251h1.5a.75.75,0,0,0,0-1.5H5.75a.75.75,0,1,0,0,1.5Z', 'M10.25,17.751h8.5a.75.75,0,0,0,0-1.5h-8.5a.75.75,0,0,0,0,1.5Z', 'M5.75,17.751h1.5a.75.75,0,0,0,0-1.5H5.75a.75.75,0,0,0,0,1.5Z']],
  AppWindowUpload: ['app-window-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.646,8.4a.5.5,0,0,1,.708,0l3,3.008a.5.5,0,0,1-.354.854H13.25a.25.25,0,0,0-.25.25v2.25a1,1,0,0,1-2,0v-2.25a.25.25,0,0,0-.25-.25H9a.5.5,0,0,1-.354-.854Z', 'M7.5,18.751h9a1.5,1.5,0,0,0,1.5-1.5V15.759a1,1,0,0,0-2,0V16.5a.25.25,0,0,1-.25.25H8.25A.25.25,0,0,1,8,16.5v-.742a1,1,0,0,0-2,0v1.492A1.5,1.5,0,0,0,7.5,18.751Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowUpload1: ['app-window-upload-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.391,5.687a.5.5,0,0,1-.391.813h-.75a.25.25,0,0,0-.25.25V20.5a1,1,0,1,1-2,0v-2.75a.25.25,0,0,0-.25-.25H15.5a.5.5,0,0,1-.391-.813l2-2.5a.52.52,0,0,1,.782,0Z', 'M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H8a1,1,0,0,0,1-1H9a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V9.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowText: ['app-window-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M10.25,10.751h8.5a.75.75,0,0,0,0-1.5h-8.5a.75.75,0,0,0,0,1.5Z', 'M5.75,10.751h1.5a.75.75,0,0,0,0-1.5H5.75a.75.75,0,0,0,0,1.5Z', 'M10.25,14.251h8.5a.75.75,0,0,0,0-1.5h-8.5a.75.75,0,0,0,0,1.5Z', 'M5.75,14.251h1.5a.75.75,0,0,0,0-1.5H5.75a.75.75,0,1,0,0,1.5Z', 'M10.25,17.751h8.5a.75.75,0,0,0,0-1.5h-8.5a.75.75,0,0,0,0,1.5Z', 'M5.75,17.751h1.5a.75.75,0,0,0,0-1.5H5.75a.75.75,0,0,0,0,1.5Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowTwo: ['app-window-two', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,4.251a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v9.5a3,3,0,0,0,3,3H15.5a3,3,0,0,0,3-3Zm-8.846-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.251Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,3.751.969.969,0,0,1,6.154,3.251Zm-3.562.091A1,1,0,0,1,3.5,2.751a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.342ZM16.5,13.751a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V6.5a.25.25,0,0,1,.25-.25h14a.25.25,0,0,1,.25.25Z', 'M24,10.251a3,3,0,0,0-3-3h-.5a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,.5.5h1.25a.25.25,0,0,1,.25.25v7.25a1,1,0,0,1-1,1H8.5a1,1,0,0,1-1-1v-.5a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Z']],
  AppWindowType: ['app-window-type', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.25,8.751a.75.75,0,0,0-.75.75v1a.75.75,0,0,0,1.5,0,.25.25,0,0,1,.25-.25h2.5a.25.25,0,0,1,.25.25V18a.75.75,0,0,0,1.5,0V10.5a.25.25,0,0,1,.25-.25h2.5a.25.25,0,0,1,.25.25.75.75,0,0,0,1.5,0v-1a.75.75,0,0,0-.75-.75Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowWarning: ['app-window-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.806,12.522a1.449,1.449,0,0,0-2.561,0l-5.056,9.633a1.43,1.43,0,0,0,.048,1.409,1.454,1.454,0,0,0,1.233.687H22.581a1.456,1.456,0,0,0,1.233-.686,1.428,1.428,0,0,0,.047-1.409Zm-2.031,3.729a.75.75,0,1,1,1.5,0v3a.75.75,0,0,1-1.5,0Zm.75,6.25a1,1,0,1,1,1-1A1,1,0,0,1,17.525,22.5Z', 'M20.976-.249h-18a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3h6a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-6a1,1,0,0,1-1-1V5a.25.25,0,0,1,.25-.25h19.5a.25.25,0,0,1,.25.25v6.25a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1v-8.5A3,3,0,0,0,20.976-.249Zm-16.654,3a.967.967,0,0,1-1.693,0,.971.971,0,0,1-.153-.5,1.01,1.01,0,0,1,1-1,.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.322,2.751Zm3.5,0a.967.967,0,0,1-1.693,0,.971.971,0,0,1-.153-.5.968.968,0,0,1,.153-.5.967.967,0,0,1,1.693,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,7.822,2.751Zm3.5,0a.967.967,0,0,1-1.693,0,.971.971,0,0,1-.153-.5.968.968,0,0,1,.153-.5.967.967,0,0,1,1.693,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.322,2.751Z']],
  MonitorChart: ['monitor-chart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,23.751a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25V20a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3V2.84A2.548,2.548,0,0,0,21.5.251H2.5A2.548,2.548,0,0,0,0,2.84V16.751a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2ZM2,2.84a.551.551,0,0,1,.5-.589h19a.551.551,0,0,1,.5.589V14.751a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M14,4.51a.249.249,0,0,0-.11-.372A4.866,4.866,0,0,0,12,3.751,4.983,4.983,0,0,0,7.131,7.7a.249.249,0,0,0,.05.21A.252.252,0,0,0,7.375,8h3.967a.5.5,0,0,0,.412-.217Z', 'M15.624,5.325a.251.251,0,0,0-.388.031L13.155,8.393a.5.5,0,0,0,.028.6l2.357,2.821a.25.25,0,0,0,.389-.006,4.933,4.933,0,0,0-.3-6.487Z', 'M7.375,9.5a.25.25,0,0,0-.244.3A4.984,4.984,0,0,0,12,13.751a4.92,4.92,0,0,0,2.317-.587.251.251,0,0,0,.075-.382L11.8,9.68a.5.5,0,0,0-.384-.179Z']],
  AppWindowDownload1: ['app-window-download-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.391,7.312-2,2.5a.5.5,0,0,1-.782,0l-2-2.5A.5.5,0,0,1,15.5,17.5h.75a.25.25,0,0,0,.25-.25V14.5a1,1,0,1,1,2,0v2.75a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.391.812Z', 'M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H8a1,1,0,0,0,1-1H9a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V9.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowPieChart: ['app-window-pie-chart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M14.042,9.174a.249.249,0,0,0,.033-.212.246.246,0,0,0-.143-.16,4.879,4.879,0,0,0-1.882-.384,4.983,4.983,0,0,0-4.869,3.947.246.246,0,0,0,.05.209.249.249,0,0,0,.194.094h4.1a.252.252,0,0,0,.207-.109Z', 'M7.425,14.168a.248.248,0,0,0-.194.093.246.246,0,0,0-.05.209,4.984,4.984,0,0,0,4.869,3.948,4.92,4.92,0,0,0,2.317-.587.25.25,0,0,0,.074-.382l-2.666-3.192a.25.25,0,0,0-.192-.089Z', 'M15.589,16.486a.25.25,0,0,0,.389-.006,4.932,4.932,0,0,0-.309-6.493.249.249,0,0,0-.2-.077.253.253,0,0,0-.187.108l-2.185,3.2a.251.251,0,0,0,.014.3Z']],
  AppWindowSearchText: ['app-window-search-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.139,18.7a5.514,5.514,0,1,0-1.691,1.69.25.25,0,0,1,.311.035l2.534,2.534a1,1,0,0,0,1.414-1.414L21.173,19.01A.25.25,0,0,1,21.139,18.7Zm-1.362-1.757A3.467,3.467,0,1,1,20,15.751,3.446,3.446,0,0,1,19.777,16.942Z', 'M11,9a.75.75,0,0,0-.75-.75h-5a.75.75,0,0,0,0,1.5h5A.75.75,0,0,0,11,9Z', 'M5.25,11.751a.75.75,0,1,0,0,1.5h2.5a.75.75,0,0,0,0-1.5Z', 'M10,20.251a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V6a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,6v2.75a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1v-5a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H9a1,1,0,0,0,1-1Zm-.346-17.5a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,2.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,3.251.969.969,0,0,1,6.154,2.751Zm-3.562.091A1,1,0,0,1,3.5,2.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,2.842Z']],
  AppWindowSync: ['app-window-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.77,18.6a1,1,0,0,0-1.271.623,4.091,4.091,0,0,1-6.918,1.419.25.25,0,0,1,.008-.345l1.722-1.721a.5.5,0,0,0-.354-.853H11.5a.5.5,0,0,0-.5.5V22.68a.5.5,0,0,0,.854.354l.969-.97a.25.25,0,0,1,.359.006,6.086,6.086,0,0,0,10.21-2.2A1,1,0,0,0,22.77,18.6Z', 'M23.691,11.773a.5.5,0,0,0-.545.109L22.12,12.908a.249.249,0,0,1-.179.073.253.253,0,0,1-.178-.077,6.1,6.1,0,0,0-10.2,2.226,1,1,0,0,0,1.893.648,4.091,4.091,0,0,1,6.9-1.445.252.252,0,0,1-.006.347L18.69,16.339a.5.5,0,0,0,.353.853H23.5a.5.5,0,0,0,.5-.5V12.235A.5.5,0,0,0,23.691,11.773Z', 'M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H8.5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V8.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowCloud: ['app-window-cloud', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.81,17.251h8.2a2.857,2.857,0,0,0,2.544-2.732,2.774,2.774,0,0,0-2.78-2.728.249.249,0,0,1-.216-.131A3.972,3.972,0,0,0,12.05,9.6a3.906,3.906,0,0,0-3.924,3.371.219.219,0,0,1-.239.191A2.093,2.093,0,0,0,5.55,15.2C5.55,17.283,7.81,17.251,7.81,17.251Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowLockAlternate: ['app-window-lock-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,0H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H5a1,1,0,0,0,0-2H3a1,1,0,0,1-1-1V7.5A.5.5,0,0,1,2.5,7h19a.5.5,0,0,1,.5.5V18a1,1,0,0,1-1,1H19a1,1,0,0,0,0,2h2a3,3,0,0,0,3-3V3A3,3,0,0,0,21,0ZM11,3.5a1,1,0,1,1-1-1A1,1,0,0,1,11,3.5Zm-3,0a1,1,0,1,1-1-1A1,1,0,0,1,8,3.5Zm-3,0a1,1,0,1,1-1-1A1,1,0,0,1,5,3.5Z', 'M15.714,15.515a.249.249,0,0,1-.214-.247V14.25a3.5,3.5,0,0,0-7,0v1.018a.249.249,0,0,1-.214.247A1.5,1.5,0,0,0,7,17v5.5A1.5,1.5,0,0,0,8.5,24h7A1.5,1.5,0,0,0,17,22.5V17A1.5,1.5,0,0,0,15.714,15.515ZM13,20.25a1,1,0,1,1-1-1A1,1,0,0,1,13,20.25Zm-2.5-6a1.5,1.5,0,0,1,3,0v1a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25Z']],
  AppWindowClock: ['app-window-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.25,24A6.75,6.75,0,1,1,24,17.251,6.758,6.758,0,0,1,17.25,24Zm0-11.5A4.75,4.75,0,1,0,22,17.251,4.756,4.756,0,0,0,17.25,12.5Z', 'M19.25,18.251h-2a1,1,0,0,1-1-1v-2.5a1,1,0,1,1,2,0V16a.25.25,0,0,0,.25.25h.75a1,1,0,0,1,0,2Z', 'M9.246,19.222A.968.968,0,0,0,8.3,18.5H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25v4.781a1,1,0,0,0,.388.777l.022.018A.983.983,0,0,0,24,10.049V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H8.3a1,1,0,0,0,.95-1.256ZM9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2Zm-3.5,0A.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5a.972.972,0,0,1-.154.5A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2Zm-3.562.091A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5.987.987,0,0,1,2.592,2.092Z']],
  AppWindowHammer: ['app-window-hammer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.979,16.669a1.146,1.146,0,0,0,1.615,0l1.026-1.026a.249.249,0,0,1,.354,0l2.318,2.323a1,1,0,0,0,1.416-1.412l-2.321-2.326a.25.25,0,0,1,0-.353l1.027-1.027a1.144,1.144,0,0,0,0-1.615L11.775,8.593a.961.961,0,0,0-.809-.335,1.137,1.137,0,0,0-.806.335L6.34,12.412a1.142,1.142,0,0,0,0,1.617Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowMail: ['app-window-mail', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,14.3a3.153,3.153,0,0,1-1.57-.418L6.375,11.551A.25.25,0,0,0,6,11.767v4.784a1.2,1.2,0,0,0,1.2,1.2h9.6a1.2,1.2,0,0,0,1.2-1.2V11.767a.25.25,0,0,0-.375-.216L13.57,13.882A3.153,3.153,0,0,1,12,14.3Z', 'M7.2,9.251a1.126,1.126,0,0,0-.6.173.25.25,0,0,0,.008.429l4.571,2.628a1.647,1.647,0,0,0,1.644,0l4.571-2.628a.25.25,0,0,0,.008-.429,1.126,1.126,0,0,0-.6-.173Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowMultiple: ['app-window-multiple', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,5.5a3,3,0,0,0-3-3H4a3,3,0,0,0-3,3V15a3,3,0,0,0,3,3H16.5a3,3,0,0,0,3-3Zm-8.846-1a.966.966,0,0,1,1.692,0A.969.969,0,0,1,12.5,5a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,10.5,5,.969.969,0,0,1,10.654,4.5Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,9,5a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,7,5,.969.969,0,0,1,7.154,4.5Zm-3.562.091A1,1,0,0,1,4.5,4a.983.983,0,0,1,.846.5A.969.969,0,0,1,5.5,5a.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,3.5,5,.987.987,0,0,1,3.592,4.592ZM17.5,15a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V7.751a.25.25,0,0,1,.25-.25h14a.25.25,0,0,1,.25.25Z', 'M7.5,21.5H20a3,3,0,0,0,3-3V7a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V18.5a1,1,0,0,1-1,1H7.5a1,1,0,0,0-1,1h0A1,1,0,0,0,7.5,21.5Z']],
  AppWindowMusic: ['app-window-music', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M11,18.751a2.5,2.5,0,0,0,2.5-2.5V11.586a.25.25,0,0,1,.388-.208l1.057.705a1,1,0,1,0,1.109-1.664l-3-2a1,1,0,0,0-1.554.832v4.261a.252.252,0,0,1-.273.249c-.075-.007-.151-.01-.227-.01a2.5,2.5,0,0,0,0,5Z']],
  MonitorShoppingCart: ['monitor-shopping-cart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.59A2.548,2.548,0,0,0,21.5,0H2.5A2.548,2.548,0,0,0,0,2.59V16.5a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3ZM2.5,15a.5.5,0,0,1-.5-.5V2.59A.551.551,0,0,1,2.5,2h19a.551.551,0,0,1,.5.589V14.5a.5.5,0,0,1-.5.5Z', 'M8.973,9.912a1.248,1.248,0,0,0,1.148.756H13.7a1.242,1.242,0,0,0,1.165-.8L16.745,5.2a.75.75,0,1,0-1.391-.561L15,5.511a.248.248,0,0,1-.231.157H9.05A1.25,1.25,0,0,0,7.9,7.41Z', 'M9.550 12.168 A1.000 1.000 0 1 0 11.550 12.168 A1.000 1.000 0 1 0 9.550 12.168 Z', 'M13.3,11.168h0a1,1,0,1,0,1,1A1,1,0,0,0,13.3,11.168Z']],
  MonitorShield: ['monitor-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.59A2.548,2.548,0,0,0,21.5,0H2.5A2.548,2.548,0,0,0,0,2.59V16.5a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3ZM2.5,15a.5.5,0,0,1-.5-.5V2.59A.551.551,0,0,1,2.5,2h19a.551.551,0,0,1,.5.589V14.5a.5.5,0,0,1-.5.5Z', 'M15.511,5.375a10.921,10.921,0,0,0-3.8-.708,10.81,10.81,0,0,0-3.764.708,1.194,1.194,0,0,0-.721,1.1V8.733A5.311,5.311,0,0,0,10.8,13.425l.369.142a1.545,1.545,0,0,0,1.1,0h0l.367-.141a5.331,5.331,0,0,0,3.6-4.692V6.471A1.2,1.2,0,0,0,15.511,5.375ZM13.98,9.168a.75.75,0,0,1-.75.75h-.5a.249.249,0,0,0-.25.25v.5a.75.75,0,0,1-1.5,0v-.5a.249.249,0,0,0-.25-.25h-.5a.75.75,0,0,1,0-1.5h.5a.25.25,0,0,0,.25-.25v-.5a.75.75,0,1,1,1.5,0v.5a.25.25,0,0,0,.25.25h.5A.75.75,0,0,1,13.98,9.168Z']],
  MonitorGraphLine: ['monitor-graph-line', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.84A2.548,2.548,0,0,0,21.5.251H2.5A2.548,2.548,0,0,0,0,2.84V16.751a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25V20a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3Zm-2,0V14.751a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V12.915a.251.251,0,0,1,.073-.177l3.75-3.75a.252.252,0,0,1,.354,0L9.47,12.281a.749.749,0,0,0,1.06,0l2-2a.75.75,0,0,0-1.06-1.06l-1.293,1.293a.252.252,0,0,1-.354,0L6.53,7.221a.749.749,0,0,0-1.06,0L2.427,10.264A.25.25,0,0,1,2,10.087V2.84a.551.551,0,0,1,.5-.589h19A.551.551,0,0,1,22,2.84Z', 'M18.394,10.436a.664.664,0,0,1-.664.664H16.094a.75.75,0,1,0,0,1.5h.143a.25.25,0,0,1,.25.25v.144a.75.75,0,0,0,1.5,0v-.208a.248.248,0,0,1,.2-.244A2.156,2.156,0,0,0,18.7,8.5L17.21,7.758a.664.664,0,0,1,.3-1.257h1.636a.75.75,0,0,0,0-1.5H19a.25.25,0,0,1-.25-.25V4.607a.75.75,0,1,0-1.5,0v.209a.249.249,0,0,1-.2.244A2.156,2.156,0,0,0,16.539,9.1l1.488.745A.658.658,0,0,1,18.394,10.436Z']],
  MonitorShield1: ['monitor-shield-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,23.751a1,1,0,0,0,0-2H12.75a.25.25,0,0,1-.25-.25V20a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3V2.84A2.548,2.548,0,0,0,21.5.251H2.5A2.548,2.548,0,0,0,0,2.84V16.751a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2ZM2,2.84a.551.551,0,0,1,.5-.589h19a.551.551,0,0,1,.5.589V14.751a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M16.7,5.215a.87.87,0,0,0-.523-.8,13.172,13.172,0,0,0-4.495-.832,12.939,12.939,0,0,0-4.459.832.87.87,0,0,0-.523.8V8.042a6.06,6.06,0,0,0,4.057,5.282l.461.176a1.3,1.3,0,0,0,.928,0l.461-.176C14.8,12.489,16.7,10.387,16.7,8.042Zm-2.25,2.87a.75.75,0,0,1-.75.75h-1a.25.25,0,0,0-.25.25v1a.75.75,0,0,1-1.5,0v-1a.25.25,0,0,0-.25-.25h-1a.75.75,0,0,1,0-1.5h1a.25.25,0,0,0,.25-.25v-1a.75.75,0,0,1,1.5,0v1a.25.25,0,0,0,.25.25h1A.75.75,0,0,1,14.45,8.085Z']],
  AppWindowLayout: ['app-window-layout', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.500 9.751 L7.500 9.751 L7.500 12.751 L4.500 12.751 Z', 'M4.500 14.751 L7.500 14.751 L7.500 17.751 L4.500 17.751 Z', 'M10.500 9.751 L13.500 9.751 L13.500 12.751 L10.500 12.751 Z', 'M10.500 14.751 L13.500 14.751 L13.500 17.751 L10.500 17.751 Z', 'M16.500 9.751 L19.500 9.751 L19.500 12.751 L16.500 12.751 Z', 'M16.500 14.751 L19.500 14.751 L19.500 17.751 L16.500 17.751 Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowRefresh: ['app-window-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.729,12.022a.5.5,0,0,0-.854-.353l-1.3,1.3a.249.249,0,0,1-.348.005,6.375,6.375,0,1,0,.627,8.631A1,1,0,0,0,20.3,20.354a4.374,4.374,0,1,1-.5-5.982.251.251,0,0,1,.009.363l-1.391,1.391a.5.5,0,0,0,.354.853h4.457a.5.5,0,0,0,.5-.5Z', 'M21,0H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H7.5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V8.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V3A3,3,0,0,0,21,0ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowSettings: ['app-window-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.248 17.001 A1.500 1.500 0 1 0 19.248 17.001 A1.500 1.500 0 1 0 16.248 17.001 Z', 'M20.4,13a.455.455,0,0,1-.533-.311L19.447,11.3a1.774,1.774,0,0,0-3.4,0l-.424,1.391a.457.457,0,0,1-.533.311L13.68,12.67a1.783,1.783,0,0,0-1.7,2.953l.989,1.065a.462.462,0,0,1,0,.625l-.987,1.066a1.783,1.783,0,0,0,1.7,2.953l1.411-.327a.456.456,0,0,1,.533.31l.424,1.392a1.774,1.774,0,0,0,3.4,0l.424-1.392a.453.453,0,0,1,.533-.31l1.412.327a1.783,1.783,0,0,0,1.7-2.953l-.988-1.066a.462.462,0,0,1,0-.625l.986-1.065a1.782,1.782,0,0,0-1.7-2.953Zm-2.656,7a3,3,0,1,1,3-3A3,3,0,0,1,17.748,20Z', 'M21,.032H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H8.5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.282a.25.25,0,0,1,.25-.25h19.5a.25.25,0,0,1,.25.25v4.25a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1v-6.5A3,3,0,0,0,21,.032Zm-16.654,3a.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5.979.979,0,0,1,.092-.408A1,1,0,0,1,3.5,1.532a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5A.969.969,0,0,1,4.346,3.032Zm3.5,0a.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,2.532a.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.969.969,0,0,1,7.846,3.032Zm3.5,0a.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.969.969,0,0,1,11.346,3.032Z']],
  AppWindowEye: ['app-window-eye', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M12.05,18.418c4.3,0,7.646-4.2,7.787-4.383a1,1,0,0,0,0-1.235c-.141-.178-3.484-4.382-7.787-4.382S4.4,12.622,4.263,12.8a1,1,0,0,0,0,1.235C4.4,14.213,7.746,18.418,12.05,18.418Zm0-8c2.328,0,4.431,1.758,5.49,2.823a.25.25,0,0,1,0,.353c-1.059,1.065-3.162,2.824-5.49,2.824s-4.431-1.759-5.49-2.824a.25.25,0,0,1,0-.353C7.619,12.176,9.722,10.418,12.05,10.418Z', 'M10.050 13.418 A2.000 2.000 0 1 0 14.050 13.418 A2.000 2.000 0 1 0 10.050 13.418 Z']],
  AppWindowRemove: ['app-window-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.651,8.091a.75.75,0,1,1-1.06,1.06l-1.414-1.414a.252.252,0,0,0-.354,0l-1.414,1.414a.75.75,0,0,1-1.06-1.06l1.414-1.414a.252.252,0,0,0,0-.354L14.849,15.91a.75.75,0,0,1,1.06-1.061l1.414,1.415a.252.252,0,0,0,.354,0l1.414-1.415a.75.75,0,1,1,1.06,1.061l-1.414,1.414a.252.252,0,0,0,0,.354Z', 'M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H8a1,1,0,0,0,1-1H9a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V9.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z']],
  AppWindowNext: ['app-window-next', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.332,11.106a.506.506,0,0,0-.527-.055.5.5,0,0,0-.28.45v2.254a.25.25,0,0,1-.242.25,7.009,7.009,0,0,0-6.758,7v2a1,1,0,0,0,2,0V21a5.006,5.006,0,0,1,4.737-4.993.25.25,0,0,1,.263.249V18.5a.5.5,0,0,0,.807.394l4.5-3.5a.5.5,0,0,0,0-.789Z', 'M9.222,19.222a.97.97,0,0,0-.951-.721h-5.3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.225,5h19.5a.25.25,0,0,1,.25.25v4.781a1,1,0,0,0,.388.777l.022.018a.983.983,0,0,0,1.59-.778V3a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3V17.5a3,3,0,0,0,3,3h5.3a1,1,0,0,0,.95-1.256ZM9.629,2a.967.967,0,0,1,1.693,0,.977.977,0,0,1,.153.5.977.977,0,0,1-.153.5A.967.967,0,0,1,9.629,3a.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.629,2Zm-3.5,0A.967.967,0,0,1,7.822,2a.977.977,0,0,1,.153.5.977.977,0,0,1-.153.5A.967.967,0,0,1,6.129,3a.969.969,0,0,1-.154-.5A.969.969,0,0,1,6.129,2Zm-3.562.092A.981.981,0,0,1,4.322,2a.977.977,0,0,1,.153.5.977.977,0,0,1-.153.5A.967.967,0,0,1,2.629,3a.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.567,2.093Z']],
  AppWindowStar1: ['app-window-star-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.666,11.733l-.013-.028a1.293,1.293,0,0,0-2.317.028L15.055,14.7a.5.5,0,0,1-.459.3H12.259a1.229,1.229,0,0,0-1.166.76,1.271,1.271,0,0,0,.319,1.4l2.059,1.835a.5.5,0,0,1,.126.572l-1.151,2.649a1.255,1.255,0,0,0,.315,1.451,1.287,1.287,0,0,0,.864.338,1.3,1.3,0,0,0,.642-.172l2.989-1.683a.5.5,0,0,1,.49,0l2.991,1.683a1.275,1.275,0,0,0,1.505-.166,1.256,1.256,0,0,0,.316-1.45l-1.152-2.65a.5.5,0,0,1,.126-.572L23.61,17.14a1.262,1.262,0,0,0,.3-1.378A1.232,1.232,0,0,0,22.74,15H20.4a.5.5,0,0,1-.459-.3Z', 'M8.5,18.5H3a1,1,0,0,1-1-1V5.25A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V11.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3H8.5a1,1,0,0,0,1-1h0A1,1,0,0,0,8.5,18.5ZM9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,9.654,3,.969.969,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2Zm-3.5,0A.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5a.969.969,0,0,1-.154.5A.966.966,0,0,1,6.154,3,.969.969,0,0,1,6,2.5.969.969,0,0,1,6.154,2Zm-3.562.092A1,1,0,0,1,3.5,1.5a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5A.966.966,0,0,1,2.654,3,.969.969,0,0,1,2.5,2.5.979.979,0,0,1,2.592,2.092Z']],
  AppWindowDisable: ['app-window-disable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.957,10.676A6.763,6.763,0,0,0,10.825,18.8a6.666,6.666,0,0,0,5.017,5.023A6.988,6.988,0,0,0,17.389,24a6.754,6.754,0,0,0,6.587-8.3A6.672,6.672,0,0,0,18.957,10.676Zm-5.323,8.929a.255.255,0,0,1-.211.071.248.248,0,0,1-.184-.126,4.38,4.38,0,0,1-.463-1.184,4.753,4.753,0,0,1,4.64-5.861,4.988,4.988,0,0,1,1.1.123,4.365,4.365,0,0,1,1.182.462.248.248,0,0,1,.126.184.255.255,0,0,1-.071.211l-.313.312-5.495,5.5Zm7.125,1.006a4.792,4.792,0,0,1-4.477,1.264,4.415,4.415,0,0,1-1.18-.461.254.254,0,0,1-.125-.184.249.249,0,0,1,.071-.211l.312-.313,5.5-5.495.313-.312a.247.247,0,0,1,.211-.071.251.251,0,0,1,.184.125,4.391,4.391,0,0,1,.462,1.181A4.8,4.8,0,0,1,20.759,20.611Z', 'M20.851,0h-18a3,3,0,0,0-3,3V17.5a3,3,0,0,0,3,3h5a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-5a1,1,0,0,1-1-1V5.253A.25.25,0,0,1,2.1,5H21.6a.25.25,0,0,1,.25.25V9a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V3A3,3,0,0,0,20.851,0ZM4.2,3A.967.967,0,0,1,2.505,3a.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.443,2.1.981.981,0,0,1,4.2,2a.977.977,0,0,1,.153.5A.977.977,0,0,1,4.2,3ZM7.7,3A.967.967,0,0,1,6.005,3a.969.969,0,0,1-.154-.5A.969.969,0,0,1,6.005,2,.967.967,0,0,1,7.7,2a.977.977,0,0,1,.153.5A.977.977,0,0,1,7.7,3Zm3.5,0A.967.967,0,0,1,9.505,3a.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.505,2,.967.967,0,0,1,11.2,2a.977.977,0,0,1,.153.5A.977.977,0,0,1,11.2,3Z']],
  AppWindow: ['app-window', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowUser: ['app-window-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.275,9.084a.75.75,0,0,0-.75-.75h-5a.75.75,0,0,0,0,1.5h5A.75.75,0,0,0,11.275,9.084Z', 'M5.525,12.834a.75.75,0,0,0,0,1.5h3a.75.75,0,1,0,0-1.5Z', 'M15.025 14.737 A3.640 3.640 0 1 0 22.305 14.737 A3.640 3.640 0 1 0 15.025 14.737 Z', 'M18.525,19.088a5.6,5.6,0,0,0-5.487,4.385.5.5,0,0,0,.487.611h10a.5.5,0,0,0,.487-.611A5.6,5.6,0,0,0,18.525,19.088Z', 'M11.975,18.417h-9a1,1,0,0,1-1-1V5.167a.25.25,0,0,1,.25-.25h19.5a.25.25,0,0,1,.25.25v3.75a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1v-6a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3h9a1,1,0,0,0,1-1h0A1,1,0,0,0,11.975,18.417ZM9.629,1.917a.967.967,0,0,1,1.693,0,.98.98,0,0,1,.153.5.974.974,0,0,1-.153.5.967.967,0,0,1-1.693,0,.966.966,0,0,1-.154-.5A.972.972,0,0,1,9.629,1.917Zm-3.5,0a.967.967,0,0,1,1.693,0,.98.98,0,0,1,.153.5.974.974,0,0,1-.153.5.967.967,0,0,1-1.693,0,.966.966,0,0,1-.154-.5A.972.972,0,0,1,6.129,1.917Zm-3.562.092a1,1,0,0,1,.908-.592.988.988,0,0,1,.847.5.98.98,0,0,1,.153.5.974.974,0,0,1-.153.5.967.967,0,0,1-1.693,0,.966.966,0,0,1-.154-.5A.983.983,0,0,1,2.567,2.009Z']],
  AppWindowLink: ['app-window-link', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.516,11.772l-1.188,1.191a1,1,0,1,0,1.416,1.412l1.187-1.19a1.828,1.828,0,1,1,2.585,2.586L20.327,16.96a1,1,0,1,0,1.414,1.414l1.189-1.189a3.828,3.828,0,1,0-5.414-5.413Z', 'M17.078,20.211l-1.257,1.257a1.828,1.828,0,0,1-2.585-2.586l1.256-1.257a1,1,0,0,0-1.414-1.414l-1.256,1.257a3.828,3.828,0,0,0,5.413,5.414l1.257-1.257a1,1,0,0,0-1.414-1.414Z', 'M19.742,14.961a1,1,0,0,0-1.414,0L14.793,18.5a1,1,0,1,0,1.414,1.414l3.535-3.535A1,1,0,0,0,19.742,14.961Z', 'M7.465,18.5H2.95a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.2,5H21.7a.25.25,0,0,1,.25.25V8.516a1,1,0,0,0,2,.017V3a3,3,0,0,0-3-3h-18a3,3,0,0,0-3,3V17.5a3,3,0,0,0,3,3H7.471A1,1,0,0,0,7.465,18.5ZM9.6,2A.967.967,0,0,1,11.3,2a.969.969,0,0,1,.154.5A.972.972,0,0,1,11.3,3,.967.967,0,0,1,9.6,3a.98.98,0,0,1-.153-.5A.977.977,0,0,1,9.6,2ZM6.1,2A.967.967,0,0,1,7.8,2a.969.969,0,0,1,.154.5A.972.972,0,0,1,7.8,3,.967.967,0,0,1,6.1,3a.98.98,0,0,1-.153-.5A.977.977,0,0,1,6.1,2Zm-3.561.091A1,1,0,0,1,3.45,1.5.983.983,0,0,1,4.3,2a.969.969,0,0,1,.154.5A.972.972,0,0,1,4.3,3,.967.967,0,0,1,2.6,3a.98.98,0,0,1-.153-.5A.987.987,0,0,1,2.542,2.092Z']],
  AppWindowLock: ['app-window-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V17.5a3,3,0,0,0,3,3h8a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H3a1,1,0,0,1-1-1V5.251A.25.25,0,0,1,2.25,5h19.5a.25.25,0,0,1,.25.25V9.5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1ZM4.346,3A.966.966,0,0,1,2.654,3,.972.972,0,0,1,2.5,2.5a.987.987,0,0,1,.092-.409A1,1,0,0,1,3.5,1.5a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5A.972.972,0,0,1,4.346,3Zm3.5,0A.966.966,0,0,1,6.154,3,.972.972,0,0,1,6,2.5.969.969,0,0,1,6.154,2,.966.966,0,0,1,7.846,2,.969.969,0,0,1,8,2.5.972.972,0,0,1,7.846,3Zm3.5,0A.966.966,0,0,1,9.654,3,.972.972,0,0,1,9.5,2.5.969.969,0,0,1,9.654,2a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.972.972,0,0,1,11.346,3Z', 'M22.714,15.516a.25.25,0,0,1-.214-.247V14.251a3.5,3.5,0,1,0-7,0v1.018a.25.25,0,0,1-.214.247A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.714,15.516ZM19,21.251a1,1,0,1,1,1-1A1,1,0,0,1,19,21.251Zm1.5-6a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1a1.5,1.5,0,1,1,3,0Z']],
  AppWindowMailAt: ['app-window-mail-at', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.05,19.251a5.722,5.722,0,0,0,1.479-.193.75.75,0,0,0-.385-1.449A4.251,4.251,0,1,1,16.3,13.5V14a.75.75,0,1,1-1.5,0,.718.718,0,0,0-.034-.167A2.608,2.608,0,0,0,14.8,13.5a2.75,2.75,0,1,0-2.75,2.75A2.726,2.726,0,0,0,13.9,15.52,2.242,2.242,0,0,0,17.8,14v-.5a5.75,5.75,0,1,0-5.75,5.75Zm0-4.5A1.25,1.25,0,1,1,13.3,13.5,1.251,1.251,0,0,1,12.05,14.751Z', 'M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  AppWindowMoveUp: ['app-window-move-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4.751a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.751Zm-3.5,0a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0A.972.972,0,0,1,6,4.251.969.969,0,0,1,6.154,3.751Zm-3.562.091A1,1,0,0,1,3.5,3.251a.983.983,0,0,1,.846.5.969.969,0,0,1,.154.5.972.972,0,0,1-.154.5.966.966,0,0,1-1.692,0,.972.972,0,0,1-.154-.5A.987.987,0,0,1,2.592,3.842ZM22,19.251a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z', 'M16.987,16.753H19a.75.75,0,1,1,0,1.5H16.987a.75.75,0,1,1,0-1.5Z', 'M10.987,16.753h2a.75.75,0,1,1,0,1.5h-2a.75.75,0,0,1,0-1.5Z', 'M4.987,16.753h2a.75.75,0,1,1,0,1.5h-2a.75.75,0,0,1,0-1.5Z', 'M11.583,8.4a.5.5,0,0,1,.707,0l2.5,2.5a.5.5,0,0,1-.353.853h-1.25a.25.25,0,0,0-.25.25V14.73a1,1,0,0,1-2,0V12a.25.25,0,0,0-.25-.25H9.437a.5.5,0,0,1-.354-.853Z']]
};
exports["default"] = _default;